/**
 * Gets a 1-based page slice of the array
 *
 * @category Array
 * @param {T[]} array - The original array
 * @param {number} pageSize - The max size of each page
 * @param {number} pageNumber - The page to fetch (1-based)
 * @returns {T[]} - The new array
 * @example
 * const array = [
 *  'dog',
 *  'cat',
 *  'fish',
 *  'hamster',
 *  'horse',
 *  'pig',
 *  'cow',
 *  'lion',
 *  'tiger',
 *  'bear',
 *  'penguin',
 *  'gorilla',
 * ];
 *
 * paginate(array, 5, 1);  // => ['dog', 'cat', 'fish', 'hamster', 'horse']
 * paginate(array, 5, 2);  // => ['pig', 'cow', 'lion', 'tiger', 'bear']
 * paginate(array, 5, 3);  // => ['penguin', 'gorilla']
 * @docgen_example
 * const array = [
 *  'dog',
 *  'cat',
 *  'fish',
 *  'hamster',
 *  'horse',
 *  'pig',
 *  'cow',
 *  'lion',
 *  'tiger',
 *  'bear',
 *  'penguin',
 *  'gorilla',
 * ];
 *
 * paginate(array, 5, 1);
 */
export var paginate = function (array, pageSize, pageNumber) {
    pageNumber -= 1; // because pages logically start with 1, but technically with 0
    return array.slice(pageNumber * pageSize, (pageNumber + 1) * pageSize);
};
